import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import {
  upsertStoreManualDayEntry,
  type StoreManualDayEntryUpsertPayload,
} from "services/auditService";

export function useAuditDashboardManualLottoPayoutDataMutation(
  storeId: string | null | undefined,
  businessDate: string | null | undefined
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: StoreManualDayEntryUpsertPayload) => {
      if (!storeId) {
        throw new Error("Store ID is required");
      }

      return upsertStoreManualDayEntry(storeId, payload);
    },
    onSuccess: async () => {
      toast.success("Lotto/Payout data saved");

      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["store-manual-day-entry", storeId, businessDate] }),
        queryClient.invalidateQueries({ queryKey: ["audit-dashboard", "store-audit-summary-range", storeId] }),
        businessDate
          ? queryClient.invalidateQueries({
              queryKey: ["audit-dashboard-daily-expanded-report", storeId, businessDate, businessDate],
            })
          : Promise.resolve(),
      ]);
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.detail || error?.message || "Failed to save Lotto/Payout data");
    },
  });
}
